import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Page, LandingContainer } from '@containers/layout';
import { Heading } from '@components/common';
import ContactForm from '@containers/auth/ContactForm';
import SignupForm from '@containers/auth/SignupForm';
import { SIGNUP_STAGE, SignupSelectors } from '@redux/SignupRedux';

function RegisterPage(props) {
  const { signupStep } = props;

  return (
    <Page>
      <LandingContainer
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Heading mb={1}>Create an Account</Heading>
        {signupStep === SIGNUP_STAGE.EMAIL ? <SignupForm /> : <ContactForm />}
      </LandingContainer>
    </Page>
  );
}

RegisterPage.propTypes = {
  signupStep: PropTypes.string.isRequired
};

const mapStatesToProps = state => ({
  signupStep: SignupSelectors.selectCurrentStep(state)
});

export default connect(mapStatesToProps)(RegisterPage);
